import $ from "jquery";

class MobileNav {
  constructor() {
    this.init();
  }

  init() {
    this.menuOpen = false;
    this.subMenuOpen = false;

    document.addEventListener("DOMContentLoaded", () => {
      this.onLoad();
    });
  }

  onLoad() {
    const wrapper = document.querySelector(".navbar-wrapper .navbar-mobile");

    this.menu = wrapper.querySelector(".nav-menu-mobile");
    this.menuToggle = wrapper.querySelector(".menu-toggle");

    this.subMenu = wrapper.querySelector(".nav-mobile-sub-menu");
    this.subMenuToggle = wrapper.querySelectorAll(".sub-menu-toggle");

    this.menuToggle.addEventListener("click", () => {
      if (this.menuOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    this.subMenuToggle.forEach((item) => {
      item.addEventListener("click", () => {
        if (this.subMenuOpen) {
          this.closeSubMenu();
        } else {
          this.openSubMenu();
        }
      });
    });
  }

  closeMenu() {
    this.menuToggle.classList.remove("active");
    this.menu.classList.remove("opened");
    this.menuOpen = false;
  }

  openMenu() {
    this.menuToggle.classList.add("active");
    this.menu.classList.add("opened");
    this.menuOpen = true;
  }

  openSubMenu() {
    this.subMenuToggle.forEach((item) => {
      item.classList.add("active");
    });
    this.subMenu.classList.add("opened");
    this.subMenuOpen = true;
  }

  closeSubMenu() {
    this.subMenuToggle.forEach((item) => {
      item.classList.remove("active");
    });
    this.subMenu.classList.remove("opened");
    this.subMenuOpen = false;
  }
}

class DesktopNav {
  constructor() {
    this.menuOpen = false;

    document.addEventListener("DOMContentLoaded", () => {
      this.onLoad();
    });
  }

  onLoad() {
    const wrapper = document.querySelector(".navbar-wrapper .navbar-desktop");

    this.header = wrapper.querySelector(".nav-header");

    this.menu = wrapper.querySelector(".nav-menu-desktop");
    this.menuToggle = wrapper.querySelector(".menu-toggle");

    this.menuToggle.addEventListener("click", () => {
      if (this.menuOpen) {
        this.closeMenu();
      } else {
        this.openMenu();
      }
    });

    const brandLinks = wrapper.querySelectorAll(".brand-link");
    const content = wrapper.querySelectorAll(".brand-content-item");

    let masterj = $(".navbar-wrapper .navbar-desktop");
    let brandLinksj = $(masterj).find(".brand-link");
    let brandContentj = $(masterj).find(".brand-content-item");

    $(brandLinksj).each((i, link) => {
      $(link).mouseenter(() => {
        $(brandContentj).removeClass("active");
        $(brandContentj).eq(i).addClass("active");
      });
    });
  }

  closeMenu() {
    this.menuToggle.classList.remove("active");
    this.menu.classList.remove("opened");
    this.header.classList.remove("opened");
    this.menuOpen = false;
  }

  openMenu() {
    this.menuToggle.classList.add("active");
    this.menu.classList.add("opened");
    this.header.classList.add("opened");
    this.menuOpen = true;
  }
}

class NavBar {
  constructor() {
    new MobileNav();
    new DesktopNav();
  }
}

export default NavBar;
